import PropTypes from "prop-types";
import { TextField, Typography } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useEffect } from "react";
import useCrud from "../../../hooks/useCrud";
import { LoadingButton } from "../../Loading";
import { AccountGroupPropTypes, AccountSubgroupPropTypes } from "../../../utils/financialHelper";

const SelectSubgrupoContabil = ({ setValues, accountSubgroup, accountGroup, isDelete: isDisabled, isRequired = true }) => {
  const defaultValues = {
    id: 0,
    name: "",
    classification: "0",
    accountGroupId: 0,
  }

  const {
    isLoading,
    items: accountSubgroups,
  } = useCrud('/account-subgroups', defaultValues, 'SelectSubgrupoContabil');

  const autoCompleteChange = (e, newValue) => {
    setValues(prev => ({
      ...prev,
      accountSubgroupId: newValue ? newValue.id : null,
      accountSubgroup: newValue,
    }))
  }

  useEffect(() => {
    // change the group, empty the subgroup
    const selectedAccountSubgroup = accountSubgroups.find(
      option => option?.id === accountSubgroup?.id
    );

    if (selectedAccountSubgroup && selectedAccountSubgroup.accountGroupId !== accountGroup?.id) {
      setValues(prev => ({
        ...prev,
        accountSubgroupId: null,
        accountSubgroup: null
      }))
    }
  }, [accountGroup, accountSubgroup, accountSubgroups, setValues]);


  return (
    <>
      {
        isLoading ? (
          <Typography variant="subtitle1">
            Carregando subgrupos contábeis...
            <LoadingButton />
          </Typography>
        ) : (
          <>
            <Autocomplete
              id="accountSubgroup"
              options={accountSubgroups.filter(option => option.accountGroupId === accountGroup?.id)}
              getOptionLabel={(option) => `(${option.classification}) - ${option.name}`}
              value={
                accountSubgroups.find(
                  option => option?.id === accountSubgroup?.id && option.accountGroupId === accountGroup?.id
                ) || null
              }
              renderInput={(params) =>
                <TextField
                  {...params}
                  label="Subgrupo Contábil"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  required={isRequired}
                />}
              onChange={autoCompleteChange}
              fullWidth
              disabled={isDisabled}
              required={isRequired}
            />
          </>
        )
      }
    </>
  );
};


SelectSubgrupoContabil.propTypes = {
  setValues: PropTypes.func.isRequired,
  accountSubgroup: PropTypes.oneOfType([
    PropTypes.shape(AccountSubgroupPropTypes),
    PropTypes.oneOf([null, undefined]),
  ]),
  accountGroup: PropTypes.oneOfType([
    PropTypes.shape(AccountGroupPropTypes),
    PropTypes.oneOf([null, undefined]),
  ]),
  isDelete: PropTypes.bool.isRequired,
  isRequired: PropTypes.bool,
};

SelectSubgrupoContabil.defaultProps = {
  accountGroup: null,
  accountSubgroup: null,
  isRequired: true,
};

export default SelectSubgrupoContabil;